import React from 'react'

import { Text, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Audience, AudienceSelector } from 'modules/competencies/components/AudienceSelector'
import { type WizardData } from 'modules/competencies/pages/CompetenciesList/NewCompetencyWizard/types'

type Props = WizardStepRenderParams<WizardData>
export const AudienceStep: React.FC<Props> = ({ data, onDataChanged }) => {
  const onChangeSelector = (audience: Audience, selectedRoles: string[]) => {
    onDataChanged({ ...data, audience: audience, roleIds: selectedRoles })
  }

  return (
    <>
      <Text.Normal>
        {i18n.t('competencies_v3.new_competency_wizard.audience_step.description')}
      </Text.Normal>
      <AudienceSelector onChangeSelector={onChangeSelector} />
    </>
  )
}
